<div class="text-center my-md-5 my-sm-3">
  <img src="assets/images/balance.svg" width="100"/>
  <h2 class="mt-5">Compare profiles</h2>
  <h6 class="mt-3 font-weight-light">Choose a profile to compare from reports you have already created or <a class="link-underlined" routerLink="/audit/add">add a new report</a></h6>
  <form class="mt-5">
    <div class="form-group">
      <div class="compare-profiles">
        <div class="input-group" *ngFor="let compare of compareCount">
          <app-profile-autocomplete (selectProfile)="onSelectProfile($event, compare)" class="w-100"></app-profile-autocomplete>
        </div>
        <button class="btn btn-light ml-md-1" type="button" (click)="increaseCompareCount()" *ngIf="compareCount.length < 5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>

          Add next profile
        </button>
      </div>
    </div>
    <div class="form-group text-center mt-5">
      <button class="btn btn-blue btn-lg btn-animated"
              type="button"
              [disabled]="!(profileState | async).loader['compare']['generate']"
              (click)="onGetCompareData()"
      >
        <span *ngIf="(profileState | async).loader['compare']['generate']">Compare profiles</span>
        <span *ngIf="!(profileState | async).loader['compare']['generate']">Loading...</span>
      </button>
    </div>
  </form>
</div>

